import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, Button, Icon } from 'antd';
import { TriggerForm } from './TriggerForm';
import { StrategyActionPanel } from './StrategyActionPanel';
import { ActionPanel } from './ActionPanel';

@inject('store')
@observer
export class TriggerCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openActions: false,
            openEdit: false
        };
    }

    renderSort() {
        const { id, max } = this.props;

        if (id === 0)
            return (
                <Icon
                    onClick={() => this.props.store.botStore.triggerStore.triggerDown(id)}
                    type="down"
                    style={{ color: '#7954ff', cursor: 'pointer', fontSize: 20 }}
                />
            );
        if (id === max - 1)
            return (
                <Icon
                    onClick={() => this.props.store.botStore.triggerStore.triggerUp(id)}
                    type="up"
                    style={{ color: '#7954ff', cursor: 'pointer', fontSize: 20 }}
                />
            );
        return (
            <Fragment>
                <Icon
                    type="up"
                    onClick={() => this.props.store.botStore.triggerStore.triggerUp(id)}
                    style={{ color: '#7954ff', cursor: 'pointer', fontSize: 20 }}
                />
                <Icon
                    type="down"
                    onClick={() => this.props.store.botStore.triggerStore.triggerDown(id)}
                    style={{ color: '#7954ff', cursor: 'pointer', fontSize: 20 }}
                />
            </Fragment>
        );
    }

    render() {
        const { trigger, id } = this.props;
        if (trigger.active === false) {
            return (
                <Card
                    title={
                        <span>
                            {this.renderSort()} {trigger.name}
                        </span>
                    }
                    size={'small'}
                    extra={
                        <Fragment>
                            <Button onClick={() => this.setState({ openEdit: true })}>Edit</Button>
                            &nbsp;&nbsp;
                            <Button
                                type={'danger'}
                                onClick={() =>
                                    this.props.store.botStore.triggerStore.removeTrigger(id)
                                }
                            >
                                Delete
                            </Button>
                        </Fragment>
                    }
                    style={{ marginBottom: 10 }}
                >
                    <i className="fal fa-info-circle" /> Rule is disabled
                    <TriggerForm
                        edit
                        id={id}
                        data={trigger}
                        visible={this.state.openEdit}
                        onCancel={() => this.setState({ openEdit: false })}
                    />
                </Card>
            );
        }
        if (!trigger.type || trigger.type === 'strategy') return this.defaultCard();
        if (trigger.type === 'time_interval') return this.timeIntervalCard();
        if (trigger.type === 'time_range') return this.timeRangeCard();
        return null;
    }

    defaultCard() {
        const { trigger, id } = this.props;
        return (
            <Card
                title={
                    <span>
                        {this.renderSort()} {trigger.name}
                    </span>
                }
                size={'small'}
                extra={
                    <Fragment>
                        <Button onClick={() => this.setState({ openEdit: true })}>Edit</Button>
                        &nbsp;&nbsp;
                        <Button
                            type={'danger'}
                            onClick={() => this.props.store.botStore.triggerStore.removeTrigger(id)}
                        >
                            Delete
                        </Button>
                    </Fragment>
                }
                style={{ marginBottom: 10 }}
            >
                <b>Symbol: </b>
                {trigger.symbol}
                <br />
                <b>Cooldown: </b>
                {trigger.cooldown}
                <br />
                <b>Can override cooldown?: </b>
                {trigger.override_cooldown ? 'Yes' : 'No'}
                <br />
                <b>Strategy: </b>
                {this.props.store.strategyStore.getStrategy(trigger.strategy_id)
                    ? this.props.store.strategyStore.getStrategy(trigger.strategy_id).name
                    : 'TRIGGER DELETED'}
                <br />

                <StrategyActionPanel mode={'buy'} triggerId={id} trigger={trigger} />
                <StrategyActionPanel mode={'sell'} triggerId={id} trigger={trigger} />

                <TriggerForm
                    edit
                    id={id}
                    data={trigger}
                    visible={this.state.openEdit}
                    onCancel={() => this.setState({ openEdit: false })}
                />
            </Card>
        );
    }

    timeRangeCard() {
        const { trigger, id } = this.props;

        return (
            <Card
                title={
                    <span>
                        {this.renderSort()} {trigger.name}
                    </span>
                }
                size={'small'}
                extra={
                    <Fragment>
                        <Button onClick={() => this.setState({ openEdit: true })}>Edit</Button>
                        &nbsp;&nbsp;
                        <Button
                            type={'danger'}
                            onClick={() => this.props.store.botStore.triggerStore.removeTrigger(id)}
                        >
                            Delete
                        </Button>
                    </Fragment>
                }
                style={{ marginBottom: 10 }}
            >
                Run rule between: <b>{trigger.start_time}</b> and <b>{trigger.end_time}</b> UTC
                <br />
                <ActionPanel mode={'default'} triggerId={id} trigger={trigger} />
                <TriggerForm
                    edit
                    id={id}
                    data={trigger}
                    visible={this.state.openEdit}
                    onCancel={() => this.setState({ openEdit: false })}
                />
            </Card>
        );
    }

    timeIntervalCard() {
        const { trigger, id } = this.props;
        return (
            <Card
                title={
                    <span>
                        {this.renderSort()} {trigger.name}
                    </span>
                }
                size={'small'}
                extra={
                    <Fragment>
                        <Button onClick={() => this.setState({ openEdit: true })}>Edit</Button>
                        &nbsp;&nbsp;
                        <Button
                            type={'danger'}
                            onClick={() => this.props.store.botStore.triggerStore.removeTrigger(id)}
                        >
                            Delete
                        </Button>
                    </Fragment>
                }
                style={{ marginBottom: 10 }}
            >
                <b>Run rule every: </b>
                {trigger.interval} minutes
                <br />
                <ActionPanel mode={'default'} triggerId={id} trigger={trigger} />
                <TriggerForm
                    edit
                    id={id}
                    data={trigger}
                    visible={this.state.openEdit}
                    onCancel={() => this.setState({ openEdit: false })}
                />
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/TriggerView/TriggerCard.js